import { useEffect, useMemo, useRef, useState } from 'react';
import { Box, Column, Row, Typography } from 'seagull';
import { Bulb24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { isFutureEffectiveDate } from "../../../../../../business-logic/billingLogic";
import { useResponsive } from "../../../../../contexts";
import { useIoContext, useStore } from "../../../../../../contexts";
import { relationshipModel } from "../../../../../../models";
import { selectors } from "../../../../../../store/state-selectors";
import { useCobConfig } from "../../../../CobConfigContext";
import { usePackageSelection } from "../../../hooks/usePackageSelection";
import { PackageCard } from "./PackageCard";
import styles from "./SelectAPackage.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetSelectAPackageTID = parentTestId => getTestIds({
  parentTestId
});
export const SelectAPackage = _ref => {
  var _relationship$service3;
  let {
    testId
  } = _ref;
  const {
    SelectAPackageTestIds
  } = useMemo(() => GetSelectAPackageTID(testId), [testId]);
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    isMobile
  } = useResponsive();
  const {
    getNow
  } = useIoContext();
  const userId = useStore(selectors.user.id);
  const isBuyer = relationshipModel.isBuyer(relationship, userId);
  const hasSignatories = relationshipModel.hasSignatories(relationship);
  const packages = useMemo(() => {
    var _relationship$service, _relationship$service2;
    return (_relationship$service = (_relationship$service2 = relationship.serviceBundles) === null || _relationship$service2 === void 0 ? void 0 : _relationship$service2.bundles) !== null && _relationship$service !== void 0 ? _relationship$service : [];
  }, [(_relationship$service3 = relationship.serviceBundles) === null || _relationship$service3 === void 0 ? void 0 : _relationship$service3.bundles]);
  const isEffectiveDateInFuture = isFutureEffectiveDate(relationship === null || relationship === void 0 ? void 0 : relationship.effectiveDate, getNow());
  const buyerFullName = relationshipModel.buyerFullName(relationship);
  const {
    selectedBundleId,
    selectPackage,
    isNavigating
  } = usePackageSelection();
  const canSelect = isPreview || isBuyer || !hasSignatories;
  const showOnlyPrimaryCallout = !isBuyer && hasSignatories;
  const containerRef = useRef(null);
  const [cardHeight, setCardHeight] = useState(undefined);
  useEffect(() => {
    if (isMobile || !containerRef.current) return;
    const calculateHeight = () => {
      const container = containerRef.current;
      if (!container) return;
      const cards = container.querySelectorAll('[data-bundleid]');
      if (cards.length === 0) return;
      setCardHeight(undefined);
      requestAnimationFrame(() => {
        let maxContentHeight = 0;
        cards.forEach(card => {
          const cardElement = card;
          maxContentHeight = Math.max(maxContentHeight, cardElement.scrollHeight);
        });
        if (maxContentHeight > 0) {
          setCardHeight(maxContentHeight);
        }
      });
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    return () => window.removeEventListener('resize', calculateHeight);
  }, [isMobile, packages]);
  return /*#__PURE__*/_jsxs(Column, {
    className: styles.root,
    testId: SelectAPackageTestIds.Root(),
    gap: 24,
    children: [showOnlyPrimaryCallout && /*#__PURE__*/_jsxs(Row, {
      gap: 12,
      alignItems: "center",
      className: styles.callout,
      testId: SelectAPackageTestIds.OnlyBuyerMessage(),
      children: [/*#__PURE__*/_jsx(Bulb24, {
        className: styles.primaryIcon
      }), /*#__PURE__*/_jsxs(Typography, {
        variant: "paragraph1",
        children: ["Only ", buyerFullName, " can select a package for this proposal"]
      })]
    }), /*#__PURE__*/_jsx(Row, {
      ref: containerRef,
      className: isMobile ? styles.packagesListMobile : styles.packagesList,
      testId: SelectAPackageTestIds.PackagesList(),
      children: packages.map((pkg, idx) => /*#__PURE__*/_jsx(Box, {
        className: isMobile ? undefined : styles.packageCardWrapper,
        testId: SelectAPackageTestIds.PackageCardWrapper(idx),
        children: /*#__PURE__*/_jsx(PackageCard, {
          package: pkg,
          isSelected: pkg.id === selectedBundleId,
          isEffectiveDateInFuture: isEffectiveDateInFuture,
          canSelect: canSelect,
          onSelect: () => selectPackage(pkg.id),
          testId: "package-card-".concat(idx),
          disabled: isNavigating,
          style: cardHeight ? {
            height: cardHeight
          } : undefined
        })
      }, pkg.id))
    })]
  });
};